import axios from '@axios'

const EMAIL_LIST_API = 'https://www.cloudfit.pro/api/v1/dev/email/list/'

const splitEmailList = raw => {
  if (!raw) return []

  return String(raw)
    .split(',')
    .map(item => item.replace(/^"|"$/g, '').trim())
    .filter(Boolean)
}

const toMailReceivers = raw => splitEmailList(raw).map(email => ({ email }))

const mapApiEmailToUiEmail = item => {
  const subject = item.subject || '(No Subject)'
  const fromEmail = item.from_email || ''
  const fromName = item.from_name || fromEmail || 'Unknown Sender'
  const messageHtml = item.body_html || ''
  const messageText = item.body_text || ''
  const displayMessage = messageHtml || messageText || subject

  return {
    id: Number(item.id),
    from: {
      avatar: '',
      name: fromName,
      email: fromEmail,
    },
    to: toMailReceivers(item.to_email),
    subject,
    message: displayMessage,
    replies: [],
    labels: [],
    folder: 'inbox',
    isRead: false,
    isStarred: false,
    hasAttachments: Number(item.has_attachment) > 0,
    attachments: [],
    time: item.received_at || item.email_date || new Date().toISOString(),
  }
}

const emptyEmailMeta = {
  inbox: 0,
  sent: 0,
  draft: 0,
  starred: 0,
  spam: 0,
  trash: 0,
}

const filterEmailsByRoute = (emails, folder, label) => {
  let result = emails

  if (folder) {
    result = result.filter(email => email.folder === folder)
  }

  if (label) {
    result = result.filter(email => email.labels.includes(label))
  }

  return result
}

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchEmails(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(EMAIL_LIST_API, {
            params: {
              page: 1,
              limit: 100,
              q: payload && payload.q ? payload.q : '',
            },
          })
          .then(response => {
            const apiList = response && response.data && response.data.data && Array.isArray(response.data.data.list)
              ? response.data.data.list
              : []

            const allEmails = apiList.map(mapApiEmailToUiEmail)
            const filteredEmails = filterEmailsByRoute(allEmails, payload && payload.folder, payload && payload.label)

            const emailsMeta = {
              ...emptyEmailMeta,
              inbox: allEmails.length,
            }

            resolve({
              data: {
                emails: filteredEmails,
                emailsMeta,
              },
            })
          })
          .catch(error => reject(error))
      })
    },
    updateEmail(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('/apps/email/update-emails', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateEmailLabels(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('/apps/email/update-emails-label', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    paginateEmail(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/email/paginate-email', { params: payload })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
